document.addEventListener("yotpoWidgetsContainerReady", function () {
  hideZeroReviews();
  renameVerifiedBuyer();
});

// Fallback (in case event fires before listener attaches)
window.addEventListener("load", function () {
  setTimeout(function () {
    hideZeroReviews();
    renameVerifiedBuyer();
  }, 2000);
});

function renameVerifiedBuyer() {
  document.querySelectorAll(".yotpo-reviewer-verified-buyer-text").forEach(function (el) {
    if (el.textContent.trim() === "Verified Buyer") {
      el.textContent = "Verified Customer";
    }
  });

  var observer = new MutationObserver(function () {
    document.querySelectorAll(".yotpo-reviewer-verified-buyer-text").forEach(function (el) {
      if (el.textContent.trim() === "Verified Buyer") {
        el.textContent = "Verified Customer";
      }
    });
  });

  var reviewsContainer = document.querySelector("[data-yotpo-instance-id] .yotpo-reviews-container");
  if (reviewsContainer) {
    observer.observe(reviewsContainer, { childList: true, subtree: true });
  }
}

function hideZeroReviews() {
  const widgets = document.querySelectorAll(".mct-item-stars-rating");

  widgets.forEach((widget) => {
    const countEl = widget.querySelector(
      ".yotpo-sr-bottom-line-text--right-panel",
    );

    if (!countEl) return;

    const reviewCount = parseInt(countEl.textContent.trim(), 10);

    if (!isNaN(reviewCount) && reviewCount === 0) {
      widget.style.opacity = "0";
      widget.style.visibility = "hidden";
      widget.style.display = "none";
    }
  });
}
